import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme) => ({
  menuItem: {
    textDecoration: 'none',
    color: theme.palette.text.primary,
    margin: `${theme.spacing(0.5)} 0`,
  },
}));
